import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Store";
import { Router } from "./Routes/Router";
import { ToastContainer } from "react-toastify";
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastContainer style={{ zIndex: 99999 }} />
      <RouterProvider router={Router} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a callback
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
